const provinces = [
  {
    code: '151',
    name: 'Arica',
    region_code: 'CL-AP',
    region_name: 'Arica y Parinacota',
    region_number: 'XV',
  },
  {
    code: '152',
    name: 'Parinacota',
    region_code: 'CL-AP',
    region_name: 'Arica y Parinacota',
    region_number: 'XV',
  },
  {
    code: '011',
    name: 'Iquique',
    region_code: 'CL-TA',
    region_name: 'Tarapacá',
    region_number: 'I',
  },
  {
    code: '014',
    name: 'Tamarugal',
    region_code: 'CL-TA',
    region_name: 'Tarapacá',
    region_number: 'I',
  },
  {
    code: '021',
    name: 'Antofagasta',
    region_code: 'CL-AN',
    region_name: 'Antofagasta',
    region_number: 'II',
  },
  {
    code: '022',
    name: 'El Loa',
    region_code: 'CL-AN',
    region_name: 'Antofagasta',
    region_number: 'II',
  },
  {
    code: '023',
    name: 'Tocopilla',
    region_code: 'CL-AN',
    region_name: 'Antofagasta',
    region_number: 'II',
  },
  {
    code: '031',
    name: 'Copiapó',
    region_code: 'CL-AT',
    region_name: 'Atacama',
    region_number: 'III',
  },
  {
    code: '032',
    name: 'Chañaral',
    region_code: 'CL-AT',
    region_name: 'Atacama',
    region_number: 'III',
  },
  {
    code: '033',
    name: 'Huasco',
    region_code: 'CL-AT',
    region_name: 'Atacama',
    region_number: 'III',
  },
  {
    code: '041',
    name: 'Elqui',
    region_code: 'CL-CO',
    region_name: 'Coquimbo',
    region_number: 'IV',
  },
  {
    code: '042',
    name: 'Choapa',
    region_code: 'CL-CO',
    region_name: 'Coquimbo',
    region_number: 'IV',
  },
  {
    code: '043',
    name: 'Limarí',
    region_code: 'CL-CO',
    region_name: 'Coquimbo',
    region_number: 'IV',
  },
  {
    code: '051',
    name: 'Valparaíso',
    region_code: 'CL-VS',
    region_name: 'Valparaíso',
    region_number: 'V',
  },
  {
    code: '052',
    name: 'Isla de Pascua',
    region_code: 'CL-VS',
    region_name: 'Valparaíso',
    region_number: 'V',
  },
  {
    code: '053',
    name: 'Los Andes',
    region_code: 'CL-VS',
    region_name: 'Valparaíso',
    region_number: 'V',
  },
  {
    code: '054',
    name: 'Petorca',
    region_code: 'CL-VS',
    region_name: 'Valparaíso',
    region_number: 'V',
  },
  {
    code: '055',
    name: 'Quillota',
    region_code: 'CL-VS',
    region_name: 'Valparaíso',
    region_number: 'V',
  },
  {
    code: '056',
    name: 'San Antonio',
    region_code: 'CL-VS',
    region_name: 'Valparaíso',
    region_number: 'V',
  },
  {
    code: '057',
    name: 'San Felipe de Aconcagua',
    region_code: 'CL-VS',
    region_name: 'Valparaíso',
    region_number: 'V',
  },
  {
    code: '058',
    name: 'Marga Marga',
    region_code: 'CL-VS',
    region_name: 'Valparaíso',
    region_number: 'V',
  },
  {
    code: '061',
    name: 'Cachapoal',
    region_code: 'CL-LI',
    region_name: "Región del Libertador Gral. Bernardo O'Higgins",
    region_number: 'VI',
  },
  {
    code: '062',
    name: 'Cardenal Caro',
    region_code: 'CL-LI',
    region_name: "Región del Libertador Gral. Bernardo O'Higgins",
    region_number: 'VI',
  },
  {
    code: '063',
    name: 'Colchagua',
    region_code: 'CL-LI',
    region_name: "Región del Libertador Gral. Bernardo O'Higgins",
    region_number: 'VI',
  },
  {
    code: '071',
    name: 'Talca',
    region_code: 'CL-ML',
    region_name: 'Región del Maule',
    region_number: 'VII',
  },
  {
    code: '072',
    name: 'Cauquenes',
    region_code: 'CL-ML',
    region_name: 'Región del Maule',
    region_number: 'VII',
  },
  {
    code: '073',
    name: 'Curicó',
    region_code: 'CL-ML',
    region_name: 'Región del Maule',
    region_number: 'VII',
  },
  {
    code: '074',
    name: 'Linares',
    region_code: 'CL-ML',
    region_name: 'Región del Maule',
    region_number: 'VII',
  },
  {
    code: '081',
    name: 'Concepción',
    region_code: 'CL-BI',
    region_name: 'Región del Biobío',
    region_number: 'VIII',
  },
  {
    code: '082',
    name: 'Arauco',
    region_code: 'CL-BI',
    region_name: 'Región del Biobío',
    region_number: 'VIII',
  },
  {
    code: '083',
    name: 'Biobío',
    region_code: 'CL-BI',
    region_name: 'Región del Biobío',
    region_number: 'VIII',
  },
  {
    code: '084',
    name: 'Ñuble',
    region_code: 'CL-BI',
    region_name: 'Región del Biobío',
    region_number: 'VIII',
  },
  {
    code: '091',
    name: 'Cautín',
    region_code: 'CL-AR',
    region_name: 'Región de la Araucanía',
    region_number: 'IX',
  },
  {
    code: '092',
    name: 'Malleco',
    region_code: 'CL-AR',
    region_name: 'Región de la Araucanía',
    region_number: 'IX',
  },
  {
    code: '141',
    name: 'Valdivia',
    region_code: 'CL-LR',
    region_name: 'Región de los Ríos',
    region_number: 'XIV',
  },
  {
    code: '142',
    name: 'Ranco',
    region_code: 'CL-LR',
    region_name: 'Región de los Ríos',
    region_number: 'XIV',
  },
  {
    code: '101',
    name: 'Llanquihue',
    region_code: 'CL-LL',
    region_name: 'Región de los Lagos',
    region_number: 'X',
  },
  {
    code: '102',
    name: 'Chiloé',
    region_code: 'CL-LL',
    region_name: 'Región de los Lagos',
    region_number: 'X',
  },
  {
    code: '103',
    name: 'Osorno',
    region_code: 'CL-LL',
    region_name: 'Región de los Lagos',
    region_number: 'X',
  },
  {
    code: '104',
    name: 'Palena',
    region_code: 'CL-LL',
    region_name: 'Región de los Lagos',
    region_number: 'X',
  },
  {
    code: '111',
    name: 'Coyhaique',
    region_code: 'CL-AI',
    region_name: 'Región Aisén del Gral. Carlos Ibañez del Campo',
    region_number: 'XI',
  },
  {
    code: '112',
    name: 'Aisén',
    region_code: 'CL-AI',
    region_name: 'Región Aisén del Gral. Carlos Ibañez del Campo',
    region_number: 'XI',
  },
  {
    code: '113',
    name: 'Capitán Pratt',
    region_code: 'CL-AI',
    region_name: 'Región Aisén del Gral. Carlos Ibañez del Campo',
    region_number: 'XI',
  },
  {
    code: '114',
    name: 'General Carrera',
    region_code: 'CL-AI',
    region_name: 'Región Aisén del Gral. Carlos Ibañez del Campo',
    region_number: 'XI',
  },
  {
    code: '121',
    name: 'Magallanes',
    region_code: 'CL-MA',
    region_name: 'Región de Magallanes y de la Antártica Chilena',
    region_number: 'XII',
  },
  {
    code: '122',
    name: 'Antártica Chilena',
    region_code: 'CL-MA',
    region_name: 'Región de Magallanes y de la Antártica Chilena',
    region_number: 'XII',
  },
  {
    code: '123',
    name: 'Tierra del Fuego',
    region_code: 'CL-MA',
    region_name: 'Región de Magallanes y de la Antártica Chilena',
    region_number: 'XII',
  },
  {
    code: '124',
    name: 'Última Esperanza',
    region_code: 'CL-MA',
    region_name: 'Región de Magallanes y de la Antártica Chilena',
    region_number: 'XII',
  },
  {
    code: '131',
    name: 'Santiago',
    region_code: 'CL-RM',
    region_name: 'Región Metropolitana de Santiago',
    region_number: 'XIII',
  },
  {
    code: '132',
    name: 'Cordillera',
    region_code: 'CL-RM',
    region_name: 'Región Metropolitana de Santiago',
    region_number: 'XIII',
  },
  {
    code: '133',
    name: 'Chacabuco',
    region_code: 'CL-RM',
    region_name: 'Región Metropolitana de Santiago',
    region_number: 'XIII',
  },
  {
    code: '134',
    name: 'Maipo',
    region_code: 'CL-RM',
    region_name: 'Región Metropolitana de Santiago',
    region_number: 'XIII',
  },
  {
    code: '135',
    name: 'Mellipilla',
    region_code: 'CL-RM',
    region_name: 'Región Metropolitana de Santiago',
    region_number: 'XIII',
  },
  {
    code: '136',
    name: 'Talagante',
    region_code: 'CL-RM',
    region_name: 'Región Metropolitana de Santiago',
    region_number: 'XIII',
  },
];

export default provinces;
